import { gql, TypedDocumentNode } from "@apollo/client";

export type PastPresidentPersonSearchNode = {
  id: string;
  pgaId: string | null;
  displayName: string;
  primarySection: { name: string | null } | null;
};

type PastPresidentPersonSearchResponse = {
  fuzzySearchPeople: { nodes: PastPresidentPersonSearchNode[] };
};

type PastPresidentPersonSearchVariables = {
  search: string;
  first: number;
};

export const PAST_PRESIDENT_PERSON_SEARCH_QUERY: TypedDocumentNode<
  PastPresidentPersonSearchResponse,
  PastPresidentPersonSearchVariables
> = gql`
  query PastPresidentPersonSearch($search: String!, $first: Int!) {
    fuzzySearchPeople(input: { search: $search }, first: $first) {
      nodes {
        id
        pgaId
        displayName
        primarySection {
          name
        }
      }
    }
  }
`;
